var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.iconName)?_c('img',{attrs:{"src":require(`@/assets/images/animation/genre-asvg/${_vm.iconName}.svg`),"width":24,"height":24,"alt":_vm.iconName}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }